import { render } from "./LoginForm.vue?vue&type=template&id=1a13f2f8&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=1a13f2f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a13f2f8"

export default script